import { CSSProperties, FormEvent, useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

/**
 * Component that renders the Stripe payment form
 */
const PaymentForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    /**
     * Handles the payment form submission
     */
    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/payment-confirmation`,
            },
        });

        if (error) {
            setErrorMessage(error.message || 'An unexpected error occurred.');
        }

        setIsLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} style={sty.form}>
            <PaymentElement />
            
            {errorMessage && (
                <div style={sty.errorMessage}>
                    {errorMessage}
                </div>
            )}
            
            <button 
                disabled={!stripe || isLoading} 
                style={sty.submitButton}
            >
                {isLoading ? 'Processing...' : 'Pay Now'}
            </button>
        </form>
    );
};

const sty: Record<string, CSSProperties> = {
    form: {
        width: '100%',
    },
    submitButton: {
        backgroundColor: '#6772e5',
        color: '#ffffff',
        border: 'none',
        borderRadius: 4,
        padding: '12px 16px',
        fontSize: 16,
        fontWeight: 600,
        width: '100%',
        marginTop: 24,
        cursor: 'pointer',
    },
    errorMessage: {
        color: '#df1b41',
        marginTop: 16,
        fontSize: 14,
    }
};

export default PaymentForm; 